import React from 'react'

import { PaginationDirection } from '~/components/dashboard/clients/balance/PaginationDirection'

export const puiPaginationSlots = {
  previous: () => <PaginationDirection direction="prev" />,
  next: () => <PaginationDirection direction="next" />,
}
